import claraLogo from './images/clara-logo.jpeg'
import claraLogoSmall from './images/clara-logo_small.png'
import heroBg from './images/hero-bg.png'

export default {
  heroBg,
  claraLogo,
  claraLogoSmall
}
